import Button from '@/shared/components/flip-ui-kit/Button';
import NavbarDropdown from '@/shared/components/PolkadotConnectionButton/NavbarDropdown';
import useBoolean from '@/shared/hooks/useBoolean';
import ChatIcon from '@/shared/icons/flip-ui-kit/large/Chat';
import DotsHorizontalIcon from '@/shared/icons/flip-ui-kit/large/DotsHorizontal';
import HelpIcon from '@/shared/icons/flip-ui-kit/large/Help';

export const MiscNavDropdownLinks = () => {
  const {
    value: isActive,
    setTrue: activateDropdown,
    setFalse: deactivateDropdown,
  } = useBoolean(false);

  return (
    <NavbarDropdown
      title={
        <Button
          type="secondary-standard"
          className="flex min-w-[40px] items-center gap-x-2 whitespace-nowrap bg-transparent !px-0"
        >
          <DotsHorizontalIcon className="h-[38px] w-[38px]" />
        </Button>
      }
      items={[
        {
          item: 'Help & Support',
          Icon: HelpIcon,
          href: 'https://discord.com/channels/824147014140952596/1463102341032050748',
        },
        {
          item: 'Leave feedback',
          Icon: ChatIcon,
          href: 'https://discord.com/channels/824147014140952596/1140570867496132649',
        },
      ].map(({ item, Icon, href }) => ({
        content: (
          <div className="whitespace-nowrap rounded-md p-1 outline-none transition hover:bg-cf-gray-4 hover:text-white">
            <a href={href} target="_blank" className="flex items-center gap-x-2" rel="noreferrer">
              <Icon />
              {item}
            </a>
          </div>
        ),
      }))}
      isActive={isActive}
      onMouseEnter={activateDropdown}
      onMouseLeave={deactivateDropdown}
    />
  );
};
